import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import ZeLightButton from "../../elements/form/ZeLightButton";

const CallForm = styled.form`
  padding-left: 30px;
  padding-top: 5px;
`;

const TextHolder = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

const CallCorrectnessHolder = styled.div.attrs({
  className: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
})`
  width: 150px;
`;

const callCorrectnessFilterOptions = [
  {
    key: "ACCEPTABLE",
    label: "Acceptable"
  },
  {
    key: "CORRECT",
    label: "Correct"
  },
  {
    key: "INCORRECT",
    label: "Incorrect"
  },
  {
    key: "UNKNOWN",
    label: "Unknown"
  },
  {
    key: "EDGE",
    label: "Edge"
  }
];

class AuditHeaderCallCorrectness extends React.Component {
  render() {
    const { auditStore } = this.props.rootStore;
    const { callCorrectnessFilterTotals } = auditStore;
    return (
      <div>
        <ZeLightButton
          className="dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Call Correctness
        </ZeLightButton>
        <CallCorrectnessHolder>
          <CallForm>
            {callCorrectnessFilterOptions.map(function(opt) {
              if (opt.key === "EDGE" && !auditStore.hasEdgeFilter) {
                return null;
              }
              const isEdge = opt.key === "EDGE";
              const checked = isEdge ? auditStore.edgeFilter : auditStore.callCorrectness[opt.key];
              const toggle = isEdge
                ? () => auditStore.toggleEdgeFilter()
                : () => auditStore.toggleCallCorrectness(opt.key);
              return (
                <div className="form-group" key={opt.key}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="dropdownCheck2"
                    checked={checked}
                    onChange={toggle}
                  />
                  <div className="d-flex justify-content-start" onClick={toggle}>
                    <TextHolder>{opt.label}</TextHolder>
                    <span className="align-items-center badge badge-light d-flex ml-1">
                      {callCorrectnessFilterTotals[opt.key]}
                    </span>
                  </div>
                </div>
              );
            })}
          </CallForm>
        </CallCorrectnessHolder>
      </div>
    );
  }
}

export default inject("rootStore")(observer(AuditHeaderCallCorrectness));
